import { render, staticRenderFns } from "./DocumentFiles.vue?vue&type=template&id=755c444c"
import script from "./DocumentFiles.vue?vue&type=script&lang=js"
export * from "./DocumentFiles.vue?vue&type=script&lang=js"
import style0 from "./DocumentFiles.vue?vue&type=style&index=0&id=755c444c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports